import React, { CSSProperties } from 'react';

type IconProps = {
  w?: number;
  h?: number;
  style?: CSSProperties;
  className?: string;
  fill?: string;
};

const TKPIcon = ({ w = 100, h = 36, style, fill, className }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={w}
      height={h}
      viewBox="0 0 100 36"
      className={className}
      style={style}
      fill={fill}
    >
      <path
        d="M22.7881 6.52099C22.7375 6.55991 22.6992 7.87926 22.6992 9.43991V12.27H28.6642V6.43213H25.7706C24.171 6.43213 22.8257 6.47105 22.7881 6.52099ZM30.5674 18.1078V29.7835H36.4052V6.43213H30.5674V18.1078ZM38.309 9.3517V12.2706H44.1468V6.43278H38.309V9.3517ZM47.0022 6.58456C46.9645 6.67343 46.9516 11.9152 46.9645 18.2349L47.0022 29.7206L49.9594 29.7582L52.9042 29.7841V21.0274H54.3377L55.7589 21.0403L58.6649 25.4057L61.5715 29.7841H68.6541L64.7829 24.0092C62.6508 20.8243 60.8995 18.1714 60.8995 18.1078C60.8995 18.0449 62.6508 15.3919 64.7829 12.207L68.6541 6.43278H61.5708L58.6649 10.8112L55.7589 15.1766L54.3371 15.1895H52.9036V6.43213H49.9847C47.763 6.43213 47.0398 6.46975 47.0015 6.58391L47.0022 6.58456ZM71.2422 6.58456C71.2039 6.67343 71.1909 11.9152 71.2039 18.2349L71.2422 29.7206H77.08L77.1176 20.9891L77.1429 12.27H86.7883V29.7835H92.6262V6.43213H81.9656C73.552 6.43213 71.2798 6.47105 71.2422 6.58456ZM14.9576 18.1078V21.0267H20.9226V15.1889H14.9576V18.1078ZM22.6992 18.1078V21.0267H28.6642V15.1889H22.6992V18.1078ZM7.216 26.8646V29.7835L10.1732 29.7582L13.1181 29.7206L13.1557 26.8269L13.181 23.9463H7.216V26.8646ZM14.9829 26.8269L15.0212 29.7199L17.9784 29.7588L20.9226 29.7835V23.9456H14.9576L14.9829 26.8269ZM22.7245 26.8269L22.7628 29.7199L25.7194 29.7588L28.6642 29.7835V23.9456H22.6992L22.7245 26.8269Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default TKPIcon;
